import { Trans } from 'react-i18next'
import CouponIcon from '@mui/icons-material/LocalOfferOutlined'

import { useDefaultPromoCode, usePromoCodeDescription } from '../../../modules/promoCodes'

const Coupon: React.FC = () => {
  const { promoCode } = useDefaultPromoCode()
  const description = usePromoCodeDescription(promoCode)

  if (!description) {
    return null
  }

  const CouponDescription = () => (<strong>{ description }</strong>)

  return (
    <div className="mb-10 mt-4 p-4 text-center text-xl text-green-700 sm:px-20 md:mb-16">
      <CouponIcon />
      { ' ' }
      <Trans i18nKey="pages.quotesRequest.preliminaryQuotes.online.coupon">
        <CouponDescription />
      </Trans>
    </div>
  )
}

export default Coupon
